import useSelectOptionsWebsite from "../useSelectOptionsWebsite/useSelectOptionsWebsite";
import { mapFaqsOptions } from "../../../utils/mapDataToOptions";

const useFaqsOptions = (endpoint) => {
  return useSelectOptionsWebsite(endpoint, mapFaqsOptions);
};

export default useFaqsOptions;
